import React from "react";

import { useAppSelector } from "../../../slices/hook";
import { getLayoutState } from "../../../slices/layouts/reducer";

import LoginComponent from "./login-component";
import SocialLoginComponent from "./social-login-component";

import { LAYOUT_NON_AUTH_THEME_TYPES } from "../../../common/constants/layout";
import BasicLayout from "../../../layout/none-auth-layout/basic";
import BoxedLayout from "../../../layout/none-auth-layout/boxed";
import CoverLayout from "../../../layout/none-auth-layout/cover";
import ModernLayout from "../../../layout/none-auth-layout/modern";

import { Mail, Smartphone } from "lucide-react";
import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";
import { BrandingData } from "admin-portal/settings/branding";

const AdminLoginPage = (props: any) => {
  document.title = "Login" + BrandingData.titleSuffix;

  const { layoutNoneAuthTheme } = useAppSelector(getLayoutState);

  const renderComponent = () => {
    switch (layoutNoneAuthTheme) {
      case LAYOUT_NON_AUTH_THEME_TYPES.MODERN:
        return (
          <ModernLayout>
            <>
              <Tab.Container defaultActiveKey="emailLogin">
                <div className="lg:w-[20rem] mx-auto mt-10">
                  {/*  <Nav className="flex flex-wrap w-full gap-2 text-sm font-medium text-center nav-tabs">
                     <Nav.Item eventKey="emailLogin" className="group grow">
                      <a
                        href="#!"
                        data-tab-toggle
                        data-target="emailLogin"
                        className="inline-block px-4 w-full py-2 text-base transition-all duration-300 ease-linear rounded-md text-slate-500 bg-slate-100 dark:text-zink-200 dark:bg-zink-600 border border-transparent group-[.active]:bg-custom-500 dark:group-[.active]:bg-custom-500 group-[.active]:text-white dark:group-[.active]:text-white hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]"
                      >
                        <Mail className="inline-block size-4 mr-1"></Mail> <span className="align-middle">Email</span>
                      </a>
                    </Nav.Item>
                     <Nav.Item eventKey="phoneLogin" className="group grow">
                      <a
                        href="#!"
                        data-tab-toggle
                        data-target="phoneLogin"
                        className="inline-block px-4 w-full py-2 text-base transition-all duration-300 ease-linear rounded-md text-slate-500 bg-slate-100 dark:text-zink-200 dark:bg-zink-600 border border-transparent group-[.active]:bg-custom-500 dark:group-[.active]:bg-custom-500 group-[.active]:text-white dark:group-[.active]:text-white hover:text-custom-500 dark:hover:text-custom-500 active:text-custom-500 dark:active:text-custom-500 -mb-[1px]"
                      >
                        <Smartphone className="inline-block size-4 mr-1"></Smartphone>{" "}
                        <span className="align-middle">Phone</span>
                      </a>
                    </Nav.Item> 
                  </Nav>*/}
                </div>
                <div className="lg:w-[25rem] mx-auto">
                  <Tab.Content className="mt-5 tab-content">
                    <Tab.Pane eventKey="emailLogin" className="tab-pane" id="emailLogin">
                      <LoginComponent></LoginComponent>
                    </Tab.Pane>
                    {/*    <Tab.Pane eventKey="phoneLogin" className="tab-pane" id="phoneLogin">
                      <form action="/" className="mt-10" id="signInForm2">
                        <div
                          className="hidden px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                          id="successAlert"
                        >
                          You have <b>successfully</b> signed in.
                        </div>
                        <div className="mb-3">
                          <label htmlFor="phoneNumber" className="inline-block mb-2 text-base font-medium">
                            Phone Number
                          </label>
                          <input
                            type="number"
                            id="phoneNumber"
                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder="Enter phone"
                          />
                          <div id="phone-error" className="hidden mt-1 text-sm text-red-500">
                            Please enter a valid email address.
                          </div>
                        </div>
                        <div className="mb-3">
                          <label htmlFor="password" className="inline-block mb-2 text-base font-medium">
                            Password
                          </label>
                          <input
                            type="password"
                            id="password2"
                            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder="Enter password"
                          />
                          <div id="password-error" className="hidden mt-1 text-sm text-red-500">
                            Password must be at least 8 characters long and contain both letters and numbers.
                          </div>
                        </div>
                        <div>
                          <div className="flex items-center gap-2">
                            <input
                              id="phoneCheckRememberMe"
                              className="size-4 border rounded-sm appearance-none bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400"
                              type="checkbox"
                              value=""
                            />
                            <label
                              htmlFor="phoneCheckRememberMe"
                              className="inline-block text-base font-medium align-middle cursor-pointer"
                            >
                              Remember me
                            </label>
                          </div>
                          <div id="remember-error" className="hidden mt-1 text-sm text-red-500">
                            Please check the "Remember me" before submitting the form.
                          </div>
                        </div>
                        <div className="mt-10">
                          <button
                            type="submit"
                            className="w-full font-medium text-white uppercase transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100"
                          >
                            Sign In
                          </button>
                        </div>
                      </form>
                    </Tab.Pane> */}
                  </Tab.Content>
                  {/*   <SocialLoginComponent></SocialLoginComponent> */}
                  {/*   <div className="mt-10 text-center">
                    <p className="mb-0 text-slate-500 dark:text-zink-200">
                      Don't have an account ?{" "}
                      <Link
                        to="/auth-register-modern"
                        className="font-semibold underline transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500"
                      >
                        {" "}
                        SignUp
                      </Link>{" "}
                    </p>
                  </div> */}
                </div>
              </Tab.Container>
            </>
          </ModernLayout>
        );
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.COVER:
        return (
          <CoverLayout>
            <>
              <div className="mt-8 text-center">
                <h4 className="mb-2 text-purple-500 dark:text-purple-500">Welcome Back !</h4>
                <p className="text-slate-500 dark:text-zink-200">Sign in to continue to {BrandingData.siteName}.</p>
              </div>

              <form action="#!" className="mt-10" id="signInForm">
                <div
                  className="hidden px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
                  id="successAlert"
                >
                  You have <b>successfully</b> signed in.
                </div>
                <div>
                  <LoginComponent></LoginComponent>
                </div>
                <div>{/*   <SocialLoginComponent></SocialLoginComponent> */}</div>

                {/*  <div className="mt-10 text-center">
                        <p className="mb-0 text-slate-500 dark:text-zink-200">Don't have an account ? <Link to="/auth-register-cover" className="font-semibold underline transition-all duration-150 ease-linear text-slate-500 dark:text-zink-200 hover:text-custom-500 dark:hover:text-custom-500"> SignUp</Link> </p>
                    </div> */}
              </form>
            </>
          </CoverLayout>
        );
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.BOXED:
        return (
          <BoxedLayout>
            <>
              <div className="text-center">
                <h4 className="mb-2 text-purple-500 dark:text-purple-500">Welcome Back !</h4>
                <p className="text-slate-500 dark:text-zink-200">Sign in to continue to {BrandingData.siteName}.</p>
              </div>
              <div>
                <LoginComponent></LoginComponent>
              </div>
              <div>{/*  <SocialLoginComponent></SocialLoginComponent> */}</div>
            </>
          </BoxedLayout>
        );
        break;
      case LAYOUT_NON_AUTH_THEME_TYPES.BASIC:
      default:
        return (
          <BasicLayout>
            <>
              <div className="mt-8 text-center">
                <h4 className="mb-1 text-custom-500 dark:text-custom-500">Welcome Back !</h4>
                <p className="text-slate-500 dark:text-zink-200">Sign in to continue to {BrandingData.siteName}.</p>
              </div>
              <div>
                <LoginComponent></LoginComponent>
              </div>
              <div>{/*  <SocialLoginComponent></SocialLoginComponent> */}</div>
            </>
          </BasicLayout>
        );
    }
  };

  return <React.Fragment>{renderComponent()} </React.Fragment>;
};

export default AdminLoginPage;
